import naja from "naja";

export default class Accordion {

    static init() {
        const toggles = document.getElementsByClassName('jsAccordionHeader');

        if (toggles.length > 0) {
            toggles.forEach( toggle => {
                const parent = toggle.closest('.accordion');

                let toMdBreakpoint = false;

                if (parent) {
                    toMdBreakpoint = parent.classList.contains('accordion--md-off') && window.matchMedia('(min-width:768px)').matches;
                }

                toggle.addEventListener('click', (e) => {

                    if (!toMdBreakpoint) {
                        if (!e.target.classList.contains('line-nav__link')) {
                            e.preventDefault();
                            let body = toggle.nextElementSibling;
                            let parentClass = toggle.dataset.parent;

                            toggle.classList.toggle(`${parentClass}__header--open`);
                            if (body) {
                                body.classList.toggle(`${parentClass}__body--open`);
                            }
                        }
                    }
                });
            });
        }
    }

    static handleProductModal() {
        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet--addedProduct' && event.detail.fromCache === false) {
                this.init();
            }
        });
    }
}
